import { Injectable } from '@angular/core';
import { SEU_ROUTES } from '@seu-helpers';
import { SeuRouteKey } from '@seu-types';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor() {}

  public getPath(
    route: SeuRouteKey,
    id?: string,
    outlets?: {
      detail: string | string[] | null;
      overview: string | string[] | null;
    }
  ): string[] {
    let path = ['/', ...SEU_ROUTES[route].path];

    if (id) {
      path = path.map((segment) => {
        return segment === ':id' ? id : segment;
      });
    }

    if (outlets) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const outletsArray: any[] = [
        {
          outlets: {
            overview: outlets?.overview
              ? typeof outlets.overview === 'string'
                ? outlets.overview
                : outlets.overview.join('/')
              : null,

            detail: outlets?.detail
              ? typeof outlets.detail === 'string'
                ? outlets.detail
                : outlets.detail.join('/')
              : null,
          },
        },
      ];

      return path.concat(outletsArray);
    }

    return path;
  }
}
